import { render, staticRenderFns } from "./kontaktModal.vue?vue&type=template&id=b6ecfbc0&scoped=true&"
import script from "./kontaktModal.vue?vue&type=script&lang=js&"
export * from "./kontaktModal.vue?vue&type=script&lang=js&"
import style0 from "./kontaktModal.vue?vue&type=style&index=0&id=b6ecfbc0&prod&lang=css&"
import style1 from "./kontaktModal.vue?vue&type=style&index=1&id=b6ecfbc0&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b6ecfbc0",
  null
  
)

export default component.exports